<template>
  <div class="auth-form__register pt-4">
    <b-overlay
      :show="isLoading"
      variant="white"
      rounded="sm"
      spinner-variant="warning"
    >
      <div class="d-flex justify-content-between mb-4">
        <div class="form-group">
          <label class="d-block">Прізвище</label>
          <input
            type="email"
            placeholder="Прізвище"
            v-model="user.last_name"
            class="d-block w-100"
          />
        </div>
        <div class="form-group">
          <label class="d-block">Ім'я</label>
          <input
            type="email"
            placeholder="Ім'я"
            v-model="user.first_name"
            class="d-block w-100"
          />
        </div>
      </div>

      <div class="form-group" v-if="!isUser">
        <label class="d-block">E-mail</label>
        <input
          type="email"
          v-model="user.email"
          placeholder="E-mail"
          class="d-block w-100"
        />
      </div>
      <div class="form-group" v-if="!isUser">
        <label class="d-block">Пароль</label>
        <input
          type="password"
          v-model="user.password"
          placeholder="Пароль"
          class="d-block w-100"
        />
      </div>
      <div class="form-group" v-if="!isUser">
        <label class="d-block">Пароль повторно</label>
        <input
          type="password"
          v-model="user.password_repeat"
          placeholder="Пароль повторно"
          class="d-block w-100"
        />
      </div>
      <div class="form-group pt-3">
        <b-button
          :disabled="registrationDisabled"
          @click="signUp()"
          variant="primary"
          class="w-100"
        >
          {{ isUser ? "Зберегти профіль" : "Зареєструватись" }}
        </b-button>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      isLoading: false,
      user: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password_repeat: "",
      },
    };
  },
  computed: {
    ...mapGetters(["isUser"]),
    registrationDisabled() {
      if (this.isLoading || !this.user.first_name.trim() || !this.user.last_name.trim()) {
        return true;
      }
      return !this.isUser && (
        !this.user.email.trim() ||
        this.user.password.length < 8 ||
        this.user.password !== this.user.password_repeat
      );
    },
  },
  methods: {
    ...mapActions(["signUpAction", "signInAction"]),
    async signUp() {
      this.isLoading = true;
      try {
        if (this.isUser) {
          await this.$resources.users.register({
            first_name: this.user.first_name,
            last_name: this.user.last_name,
          });
          this.$toast.success("Профіль створено");
          this.$bvModal.hide("auth-modal");
          window.location.reload();
          return;
        }
        if (this.user.password !== this.user.password_repeat) {
          this.$toast.error("Паролі не співпадають");
          return;
        }
        await this.$resources.users.createAccount({
          email: this.user.email,
          password: this.user.password,
          first_name: this.user.first_name,
          last_name: this.user.last_name,
        });
        const result = await this.$auth.signInWithEmail(
          this.user.email,
          this.user.password
        );
        if (!result.success) throw result;
        this.$toast.success("Реєстрація успішна");
        if (this.$route.name !== "services") {
          this.$router.push({ name: "services" });
        }
        this.$bvModal.hide("auth-modal");
      } catch (error) {
        const code = error.response && error.response.data
          ? error.response.data.error
          : error.code;
        const errorText = code === "email-already-exists"
          ? "Цей Email вже використовується"
          : code === "invalid-email"
            ? "Невірно вказано емейл"
            : "Не вдалося зареєструватися. Перевірте дані та спробуйте ще раз.";
        this.$toast.error(errorText);
      } finally {
        this.isLoading = false;
      }
    },
    async saveUserDataToRemote(user) {
      this.isLoading = true;
      user["auto_create"] = "on";

      fetch("https://project.realno.top/api/user/set/", {
        method: "POST", // или 'PUT'
        body: JSON.stringify(user),
        // mode: "no-cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          console.log(response);
          return response.json();
        })
        .then((data) => {
          console.log(data);
          this.isLoading = false;
          // this.$toast.success("Зміни збережено");
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
